const PageTitle = ({ children }) => (
  <div className="box">
    <p className="title is-4 has-text-right">{children}</p>
  </div>
)

export default PageTitle
